import { noShowAppointment, partsRequiredAppointment } from "API";
import React from "react";
import { formatDateTime } from "utils/FormatDate";
import { useState, useEffect } from "react";
import { HiOutlineUserCircle, HiOutlineClock, HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { FaCarSide } from "react-icons/fa";
import { useNavigate } from "react-router-dom";




const JobCard = ({ data, completeJob, viewOwner, setOwnerModalData, setVin }) => {

  const {
    client,
    start,
    status,
    services,
    vehicle,
    id,
  } = data;

  console.log("This is beginnisng", data)

  const navigate = useNavigate();


  const vehicleText = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;

  const [completed, setCompleted] = useState(
    status === "scheduled" ? false : true
  );


  useEffect(() => {
    setJobStatus(status);
    setCompleted(status !== "scheduled");
  }, [status]);


  const [jobStatus, setJobStatus] = useState(status);

  return (
    <div
      className={`w-full max-w-sm rounded-2xl border border-gray-200 bg-white p-4 shadow-sm
             transition-all duration-200 ease-out
             hover:shadow-lg hover:border-gray-300`}
    >

      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2 text-gray-700">
          <HiOutlineClock className="text-lg text-gray-500" />
          <span className="text-sm font-semibold">{formatDateTime(start)}</span>
        </div>

        <div className="flex items-center gap-2">

          <button
            type="button"
            onClick={()=>{
              setOwnerModalData(client);
              viewOwner();

            }}
            className="rounded-full p-2 text-gray-600 hover:bg-gray-100 hover:text-blue-600"
            title="View contact details"
          >
            <HiOutlineUserCircle className="text-2xl" />
          </button>


          {jobStatus === "completed" ? (
            <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
              {jobStatus}
            </span>
          ) : jobStatus === "scheduled" ? (
            <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
              {jobStatus}
            </span>
          ) : jobStatus === "no show" ? (
            <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-700">
              {jobStatus}
            </span>
          ) : jobStatus === "parts required" ? (
            <span className="rounded-full bg-pink-100 px-3 py-1 text-xs font-medium text-pink-700">
              {jobStatus}
            </span>
          ) : (
            <span className="rounded-full bg-yellow-100 px-3 py-1 text-xs font-medium text-yellow-700">
              Unknown
            </span>
          )}
        </div>
      </div>


      <div className="mt-3 rounded-xl bg-gray-50 p-3">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="truncate text-base font-semibold text-gray-900">
              {vehicleText}
            </h3>
            <p className="mt-0.5 text-xs text-gray-500">
              {vehicle?.current_odo_km} kms
            </p>
            <p className="mt-1 flex items-center gap-2 text-xs text-gray-500 w-full">
              <span>VIN:</span>
              {vehicle?.vin ? (
                <span>{vehicle.vin}</span>
              ) : (
                
                <button onClick={() => setVin(vehicle)} className="inline-flex h-9 w-9 mx-2 items-center justify-center rounded-lg bg-white shadow-sm hover:bg-gray-100 transition">
                  +
                </button>
              )}
            </p>

          </div>

          <button
            onClick={() => {
              navigate("/vehicle-maintenance-record", {
                state: { vehicle: vehicle },
              })
              console.log("Captureddd", vehicle.id)
            }
            }
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-white shadow-sm hover:bg-gray-100 transition"
            aria-label="View vehicle maintenance record"
          >
            <FaCarSide className="text-xl text-gray-700" />
          </button>
        </div>
      </div>

      {/* Services */}
      <div className="mt-4">
        <p className="flex items-center gap-2 text-sm font-semibold text-gray-800">
          <HiOutlineWrenchScrewdriver className="text-lg text-gray-500" />
          Service Requested
        </p>

        <ul className="mt-2 space-y-2">
          {services.map((service, index) => (
            <li
              key={index}
              className="flex items-center justify-between rounded-lg border border-gray-100 bg-white px-3 py-2"
            >
              <span className="text-sm font-medium text-gray-800">
                {service.name}
              </span>
              <span className="text-xs font-semibold text-gray-600">
                {service.time_taken} mins
              </span>
            </li>
          ))}
        </ul>
      </div>


      {completed ? null : (
        <div className="mt-4 space-y-3">
          <button
            onClick={() => {
              completeJob(id);
              setCompleted(true);
              setJobStatus("completed");
            }}
            className="w-full rounded-xl bg-green-600 py-2.5 text-sm font-semibold text-white hover:bg-green-700"
          >
            Complete Job
          </button>

          <div className="flex gap-3">
            <button
              onClick={() => {
                partsRequiredAppointment(id);
                setCompleted(true);
                setJobStatus("parts required");
              }}
              className="w-full rounded-xl bg-yellow-500 py-2.5 text-sm font-semibold text-black hover:bg-yellow-600"
            >
              Parts Required
            </button>

            <button
              onClick={() => {
                noShowAppointment(id);
                setCompleted(true);
                setJobStatus("no show");
              }}
              className="w-full rounded-xl bg-red-600 py-2.5 text-sm font-semibold text-white hover:bg-red-700"
            >
              No Show
            </button>
          </div>
        </div>
      )}

      

    </div>
  );
};

export default JobCard;
